import {
    Component,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

import {
    AlSelectItem,
    AlSelectableListConfig,
    AlSelectableList
} from '../types';

import {
    AIMSUser
} from '@al/core';

@Component({
    selector: 'al-selectable-list-v2',
    templateUrl: './al-selectable-list-v2.component.html',
    styleUrls: ['./al-selectable-list-v2.component.scss']
})
export class AlSelectableListV2Component {

    @Input() config: AlSelectableListConfig = {
        zeroStateIcon: '',
        zeroStateMessage: 'No items chosen yet',
        height: '350px',
        sortDirection: 'asc',
        sortBy: 'title',
        action: {}
    };
    @Input() data: AlSelectableList[] = [];

    @Output() onActionedItem: EventEmitter<AlSelectableList> = new EventEmitter<AlSelectableList>();
    @Output() onActionedSubItem: EventEmitter<AlSelectItem> = new EventEmitter<AlSelectItem>();

    constructor() { }

    actionItem(element: AlSelectableList): void {
        this.onActionedItem.emit(element);
    }

    onSubItemAction(subItem: AlSelectItem): void {
        this.onActionedSubItem.emit(subItem);
    }

}
